export enum UBAActionType {
  Deposit = "deposit",
  Refund = "refund",
}
